import { AfterViewInit, Directive, ElementRef, EventEmitter, inject, Input, OnDestroy, Output } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

@Directive({
  selector: '[fgbAnimateOnScroll]',
  standalone: true,
})
export class AnimateOnScrollDirective implements AfterViewInit, OnDestroy {
  @Input() animationType: 'scrollDown' | 'scrollUp' | 'scale' = 'scale';
  @Output() onScroll: EventEmitter<{ progress: number }> = new EventEmitter();
  private st?: GSAPTween;
  private _el = inject(ElementRef);
  private mm = gsap.matchMedia();

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      this.mm.add('screen and (max-width: 768px)', () => {
        const tween = gsap.to(this._el.nativeElement, {
          ...this.animation,
          ease: 'none',
          scrollTrigger: {
            trigger: this._el.nativeElement,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
            onUpdate: (self) => {
              const percent = (self.progress * 100).toFixed(2);
              this.onScroll.emit({ progress: parseFloat(percent) });
            },
          },
        });

        this.st = tween;
        return () => {
          if (this.st?.scrollTrigger) {
            this.st.scrollTrigger.kill();
          }
          gsap.set(this._el.nativeElement, { scale: 1, opacity: 1 });
        };
      });
    });

    // Force ScrollTrigger to recalc positions (important in SPAs)
    ScrollTrigger.refresh();
  }

  get animation() {
    switch (this.animationType) {
      case 'scrollDown':
        return { y: 100, opacity: 0 };
      case 'scrollUp':
        return { y: -100, opacity: 0 };
      case 'scale':
      default:
        return { scale: 0.7, opacity: 0, transformOrigin: 'top center' };
    }
  }

  ngOnDestroy() {
    if (this.st?.scrollTrigger) {
      this.st.scrollTrigger.kill();
    }
    this.mm.revert();
  }
}
